import React from 'react'

import { Heading } from '../'

export const ReportSection = ({ heading, data, primaryValueColours, secondaryValues, leftAlign, className }) => {
  let columnSize = `slds-size_1-of-${leftAlign ? '4' : Object.keys(data).length}`

  // TODO: add ability to specify how many columns per row to display

  let reportData = Object.entries(data).map((entry, index) => (
    <div
      className={`data-group slds-p-right_medium ${columnSize}`}
      key={`reportData_${index}`}>
      <div className='data-group__title slds-text-heading_medium'>
        {entry[0]}  {/* display data object key */}
      </div>
      <div className={`data-group__value ${primaryValueColours ? `data-color_${primaryValueColours[index]}` : 'data-color_neutral'} slds-text-heading_large`}>
        {entry[1]}  {/* display data object value */}
      </div>
      {secondaryValues &&
        <div className='data-group__value_secondary'>
          {secondaryValues[index]}
        </div>
      }
    </div>
  ))

  return (
    <div className={`slds-grid slds-wrap u-bg-color-white slds-p-left_x-large slds-p-top_x-large slds-p-right_x-large ${className ? className : ''}`}>
      <div className='slds-size_1-of-1 slds-m-bottom_x-large'>
        <Heading size='large' className='data-section__heading'>
          {heading}
        </Heading>
      </div>
      {reportData}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/report-section/index.js